import {
  richtext_default
} from "../../chunk-AOYEWCXX.js";
export {
  richtext_default as default
};
